export const resultsPerPage = 6 